var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sos-link"},[_c('div',{staticClass:"sos-link-icon"},[_c('i',{staticClass:"icon",class:_vm.linkIcon})]),_c('div',{staticClass:"sos-link-content"},[_c('p',{staticClass:"sos-link-title"},[_vm._v(_vm._s(_vm.linkTitle))]),(_vm.linkText)?_c('p',{staticClass:"sos-link-text"},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }